"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IFFUsersHeader_1 = __importDefault(require("./components/IFFUsersHeader"));
const UsersTableSection_1 = __importDefault(require("./components/UsersTableSection"));
const CreateUserModal_1 = __importDefault(require("./components/UserForms/CreateUserModal"));
const EditUserModal_1 = __importDefault(require("./components/UserForms/EditUserModal"));
const UsersToast_1 = __importDefault(require("./components/UsersToast"));
const DeleteUserDialogAlert_1 = __importDefault(require("./components/DeleteUserDialogAlert"));
function UsersView() {
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 4 },
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true },
            react_1.default.createElement(IFFUsersHeader_1.default, null)),
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true },
            react_1.default.createElement(UsersTableSection_1.default, null),
            react_1.default.createElement(CreateUserModal_1.default, null),
            react_1.default.createElement(EditUserModal_1.default, null),
            react_1.default.createElement(UsersToast_1.default, null),
            react_1.default.createElement(DeleteUserDialogAlert_1.default, null))));
}
exports.default = UsersView;
